export function isActiveElementInputLike(): boolean {
  const active = document.activeElement;
  return !!(
    active &&
    (
      active.tagName === 'INPUT' ||
      active.tagName === 'TEXTAREA' ||
      (active as HTMLElement).isContentEditable
    )
  );
}
